<template>
  <lb-dialog v-model="localBulkSubmitRuDialog" :heading="`Bulk Upload ${$nova.labelsName('access_management','commenrary_ru_label','RU')} Level Access`"
    :width="(bulkSubmitRuFileData.length > 0)?'80%':'60%'" :loading="bulkSubmitRuLoading">
    <template v-slot:body>
      <div>
        <div v-if="bulkSubmitRuFileData.length === 0">
          <div class="mb-2 d-flex flex-column align-center justify-center gap-3">
            <div class="d-flex justify-start" style="width: 100%">
              <v-btn color="primary" target="_blank"
                @click="generateBulkSubmitFile"><span>Download template</span></v-btn>
            </div>
            <DragDropFileWithIcon
              :files="bulkSubmitRuFile ? [bulkSubmitRuFile] : []"
              :loading="fileProcessing && fileProcessing['file'] === 1"
              :multiplefiles="false"
              accept=".xlsx,.xls,.xlsm,.xlsb"
              @update:files="handleBulkSubmitFileUpdate"
            />
          </div>
          <div class="grey--text pa-6 text-center title">
            Download the template, update the details and upload the file.
          </div>
        </div>
        <div v-else class="d-flex flex-column gap-3">
          <div class="d-flex justify-space-between gap-2">
            <v-btn color="primary" target="_blank" class=""
              @click="generateBulkSubmitFile"><span>Download template</span></v-btn>
            <v-btn class="secondaryBtn" outlined @click="reUploadFile">
              <v-icon left>mdi-upload</v-icon>
              <span>Re-upload</span>
            </v-btn>
          </div>
          <lb-datatablenew
            :headers="bulkSubmitHeaders"
            :items="bulkSubmitRuFileData"
            :enableslot="['rucode', 'l_preparer', 'l_approver', 'r_approver', 'manager']"
            :hideColumnSelector="true"
            :loading="false"
          >
            <template v-slot:rucode="{ item }">
              <v-tooltip v-if="bulkSubmitRuFileError[bulkSubmitRuFileData.indexOf(item)] && bulkSubmitRuFileError[bulkSubmitRuFileData.indexOf(item)]['rucode']" bottom content-class="tooltip-bottom">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" class="error--text font-weight-bold">{{ item.rucode || '' }}</span>
                </template>
                <span>{{ bulkSubmitRuFileError[bulkSubmitRuFileData.indexOf(item)]['rucode'] }}</span>
              </v-tooltip>
              <div v-else>{{ item.rucode || '' }}</div>
            </template>

            <template v-for="col in ['l_preparer', 'l_approver', 'r_approver', 'manager']" v-slot:[col]="{ item }">
              <div class="d-flex flex-wrap" :key="col">
                <div
                  v-for="(nv, nk) in (item[col] || [])"
                  :key="`bulk-chip-${col}-${nk}`"
                  class="d-inline-flex"
                >
                  <v-tooltip
                    v-if="bulkSubmitRuFileError[bulkSubmitRuFileData.indexOf(item)][col] && bulkSubmitRuFileError[bulkSubmitRuFileData.indexOf(item)][col][nk]"
                    bottom
                    content-class="tooltip-bottom"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        label
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        class="error--text font-weight-bold mr-1 mb-1"
                      >
                        <v-icon left>mdi-account</v-icon><span class="noTransform">{{ nv || 'Error' }}</span>
                      </v-chip>
                    </template>
                    <span>{{ bulkSubmitRuFileError[bulkSubmitRuFileData.indexOf(item)][col][nk] }}</span>
                  </v-tooltip>
                  <v-tooltip
                    v-else-if="bulkSubmitRuFileWarn[bulkSubmitRuFileData.indexOf(item)][col] && bulkSubmitRuFileWarn[bulkSubmitRuFileData.indexOf(item)][col][nk]"
                    bottom
                    content-class="tooltip-bottom"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        label
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        class="warning--text font-weight-bold mr-1 mb-1"
                      >
                        <v-icon left>mdi-account</v-icon><span class="noTransform">{{ nv || 'Warn' }}</span>
                      </v-chip>
                    </template>
                    <span>{{ bulkSubmitRuFileWarn[bulkSubmitRuFileData.indexOf(item)][col][nk] }}</span>
                  </v-tooltip>
                  <v-chip
                    v-else
                    label
                    outlined
                    class="mr-1 mb-1"
                  >
                    <v-icon left>mdi-account</v-icon><span class="noTransform">{{ nv || '' }}</span>
                  </v-chip>
                </div>
              </div>
            </template>
          </lb-datatablenew>
        </div>
      </div>
    </template>
    <template v-slot:actions>
      <div v-if="emptyRuCode" class="error--text font-weight-bold">
        Ru code can't be empty.
      </div>
      <div v-if="bulkSubmitRuFileErrorFlag" class="px-2 error--text font-weight-bold">
        Please provide all valid details
      </div>
      <v-spacer></v-spacer>
      <v-btn v-if="bulkSubmitRuFileData.length > 0 && !bulkSubmitRuFileErrorFlag && !emptyRuCode"
        @click="$emit('update-user-access')" color="primary" class="ml-2 shadow-off"><span>Proceed to Upload</span></v-btn>
    </template>
  </lb-dialog>
</template>

<script>
let styledxlsx = require('sheetjs-style');
import DragDropFileWithIcon from "../../../../../views/Inputs/DragDropFileWithIcon.vue";

export default {
  name: 'BulkUploadDialog',
  components: {
    DragDropFileWithIcon
  },
  props: {
    value: { type: Boolean, default: false },
    bulkSubmitRuFileData: { type: Array, default: () => [] },
    bulkSubmitRuLoading: { type: Boolean, default: false },
    bulkSubmitRuFile: { type: [File, Object], default: null },
    // fileProcessing: { type: Object, default: () => ({}) }, // Moved to local state
    bulkSubmitRuFileError: { type: Array, default: () => [] },
    bulkSubmitRuFileWarn: { type: Array, default: () => [] },
    bulkSubmitHeaders: { type: Array, default: () => [] },
    bulkSubmitRuFileErrorFlag: { type: Boolean, default: false },
    emptyRuCode: { type: Boolean, default: false },
    
    // Validations dependencies
    rucodeidmap: { type: Object, default: () => ({}) },
    rucodenamemap: { type: Object, default: () => ({}) },
    ruidDataMap: { type: Object, default: () => ({}) },
    formatedData: { type: Array, default: () => [] },
    useremailidmap: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      fileProcessing: {}
    }
  },
  computed: {
    localBulkSubmitRuDialog: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); }
    }
  },
  methods: {
    reUploadFile() {
      // Logic for re-upload: reset parent state
      this.$emit('update:bulkSubmitRuFile', null);
      this.$emit('update:bulkSubmitRuFileData', []);
      this.$emit('update:bulkSubmitRuFileError', []);
      this.$emit('update:bulkSubmitRuFileWarn', []);
      this.$emit('re-upload-file'); // To notify parent if needed
    },
    generateBulkSubmitFile() {
      return Promise.resolve().then(() => {
          
          const workbook = styledxlsx.utils.book_new();
          // ========== SHEET: Instructions ==========
          let instructionsData = this.$constants.BULK_FILE_TEMPLATES.BULK_ACCESS_RIGHTS_UPLOAD_INSTRUCTIONS;
          let headers = this.$constants.BULK_FILE_TEMPLATES.BULK_ACCESS_RIGHTS_UPLOAD;
          headers = headers.map((label) => this.$nova.identifyAndRemapLabelName(this.$constants.BULK_FILE_TEMPLATES.LABELS_PAGE, label));
          instructionsData = instructionsData.map((item) => {
            item[1] = this.$nova.identifyAndRemapLabelName(this.$constants.BULK_FILE_TEMPLATES.LABELS_PAGE, item[1], true);
            return item;
            });
          const ws1 = styledxlsx.utils.aoa_to_sheet(instructionsData);
          ws1["B2"].s = {
            font: { bold: true } 
          };

          styledxlsx.utils.book_append_sheet(workbook, ws1, "Instructions");

          // ========== SHEET: TOP SHEET ==========
          const topData = [
            [...headers]
          ];
          for(let i = 0; i < 15; i++) {
            topData.push([...Array(headers.length).fill("")]);
          }

          const ws2 = styledxlsx.utils.aoa_to_sheet(topData);

          // Set column widths to match content
          ws2['!cols'] = [];
          // Set default width for all columns based on content in row 3
            for (const col of topData[0]) {
            const content = String(col || '');
            const width = Math.max(10, content.length * 1.2);
            ws2['!cols'].push({ width });
          }

          // Styling
          const headerFill = {
            patternType: "solid",
            fgColor: { rgb: "FF2F5597" }  // Blue-ish header
          };

          // Apply fill to merged header
          ["A1", "B1", "C1", "D1", "E1", "F1"].forEach(cell => {
            if (ws2[cell]) ws2[cell].s = { font: { bold: true, color: { rgb: "FFFFFF" }}, alignment: {
                horizontal: "center",
                vertical: "center"
              }, fill: headerFill };
          });

          // Add borders to all cells in the first 10 rows and up to startIndex + 15 columns
          const borderStyle = { style: "thin", color: { rgb: "000000" } };
          for (let r = 0; r < 16; r++) {
            for (let c = 0; c <= 5; c++) {
              const cellRef = styledxlsx.utils.encode_cell({ r, c });
              // Initialize cell if it doesn't exist
              if (!ws2[cellRef]) {
                ws2[cellRef] = { v: "", t: "s" }; // 't: "s"' ensures it's treated as string
              }

              // Ensure style object exists
              if (!ws2[cellRef].s) ws2[cellRef].s = {};

              // Set border and number format
              ws2[cellRef].s.border = {
                top: borderStyle,
                bottom: borderStyle,
                left: borderStyle,
                right: borderStyle
              };
            }
          }

          styledxlsx.utils.book_append_sheet(workbook, ws2, "TOP SHEET");

          // Export file
          styledxlsx.writeFile(workbook, `Template_Access_${this.$nova.labelsName('access_management','commenrary_ru_label','RU').trim()}_level.xlsx`);

      }).catch(err => {
        this.$store.commit("sbError", err.message || err || "Unknown error!");
        console.log(err);
      }).finally(() => {
        // Nothing to do here
      })
    },

    handleBulkSubmitFileUpdate(files) {
      if (files && files.length > 0) {
        this.$emit('update:bulkSubmitRuFile', files[0]);
        // this.bulksubmitrufile = files[0];
        this.readBulkSubmitFile(files[0], 'file');
      } else {
        this.$emit('update:bulkSubmitRuFile', null);
      }
    },

    readBulkSubmitFile(file, key) {
      this.$emit('update:emptyRuCode', false);
      let errorMessages = {
        "existingaspreparer":"Already exists as a Local Preparer",
        "existingasapprover":"Already exists as a Local Approver",
        "existingasregionalapprover":"Already exists as a Regional Approver",
        "existingasmanager":"Already exists as a Manager",
      }
      Object.entries(errorMessages).forEach(([key, value]) => {
        // Update values based on your requirements
        // For example, add a prefix to each message:
        errorMessages[key] = this.$nova.identifyAndRemapLabelName(this.$constants.BULK_FILE_TEMPLATES.LABELS_PAGE, value, true);
      });
      
      // let file = this.bulksubmitrufile;
      if ((file || {}).name && (this.fileProcessing[key] || 0) === 0) {
        let headings = this.$constants.BULK_FILE_TEMPLATES.BULK_ACCESS_RIGHTS_UPLOAD;
        headings = headings.map((label) => this.$nova.identifyAndRemapLabelName(this.$constants.BULK_FILE_TEMPLATES.LABELS_PAGE, label));
        // console.log(file);
        // this.bulksubmitruloading = true; // Use prop if possible or emit
        this.$emit('update:bulkSubmitRuLoading', true);
        
        this.$set(this.fileProcessing, key, 1);
        
        let ext = ((file || {}).name || "").split(".").pop();
        Promise.resolve().then(() => {
          if (["xlsx", "xls", "xlsm", "xlsb"].indexOf(ext) === -1) throw new Error("Invalid file format. Please upload a valid Excel file (.xlsx, .xls, .xlsm, .xlsb).");
          return this.$nova.readExcelFile(file, "TOP SHEET");
        }).then(dt => {
          if (JSON.stringify(dt[0] || []) === JSON.stringify(headings)) {
            let filedata = [];
            let errordata = [];
            let warning_data = [];
            let errorFlag = false;
            let visitedRUCodes=[];
            let localEmptyRuCode = false;

            for (let i = 0; i < dt.length; i++) {
              if (i > 0) {
                const el = dt[i];
                if (el.join("") !== "") {
                    let errors = {};
                    let warn_data = {};
                    let startindex = 2;
                    let rowdata = {
                      "rucode": el[0]?.trim(),
                      "ruid": this.rucodeidmap[el[0]?.trim()] || 'NA',
                      "runame": this.rucodenamemap[el[0]?.trim()]|| el[1] || "",
                      'l_preparer':[],
                      'l_approver': [],
                      'r_approver': [],
                    };
                    if(el[0]?.trim() === undefined)
                    {
                      localEmptyRuCode = true;
                    }
                    // Check if SOD is enabled for this RU
                    const ruData = this.ruidDataMap[this.rucodeidmap[rowdata.rucode]];
                    const isSodEnabled = ruData?.sodEnabled === true;
                    if(visitedRUCodes.indexOf(rowdata.rucode) > -1) errors["rucode"] = "Duplicate code found" 
                    if (!this.rucodenamemap[rowdata.rucode]) errors["rucode"] =  `${this.$nova.labelsName('materiality_page','unit_code_label','RU Code')} not found`;
                    else visitedRUCodes.push(rowdata.rucode)                    
                    let filterdata = this.formatedData.filter((x) => x.code === rowdata.rucode);
                    // Local preparer validation
                    if(el[startindex + 0]) {
                        let terrors = [];
                        let tids = [];
                        let warn_users = [];
                        let temails = el[startindex + 0].split(",");
                        temails = temails.map(email => email.trim());
                        for (let email of temails) {
                            if (this.useremailidmap[email]) {
                                let isPreparer = filterdata?.[0]?.submitter?.some(item => item.name === email);
                                let isApprover = filterdata?.[0]?.approver?.some(item => item.name === email);
                                let isRegionalApprover = filterdata?.[0]?.regional_approver?.some(item => item.name === email);
                                let isManager = filterdata?.[0]?.manager?.some(item => item.name === email);
                                if (!isPreparer && tids.indexOf(this.useremailidmap[email]) === -1) {
                                    // If the email is not found in any role, push it to tids array
                                    tids.push(this.useremailidmap[email]);
                                    if (isApprover) {
                                        warn_users.push(errorMessages.existingasapprover);
                                    } else if (isRegionalApprover) {
                                        warn_users.push(errorMessages.existingasregionalapprover);
                                    } else if (isManager) {
                                        warn_users.push(errorMessages.existingasmanager);
                                    }
                                    terrors.push("");
                                } else {
                                  // If the email is found in any role, push the corresponding error message
                                  if (isPreparer) {
                                    terrors.push(errorMessages.existingaspreparer);
                                  } else if(tids.indexOf(this.useremailidmap[email]) > -1){
                                    terrors.push("Duplicate email found");
                                  }
                                }
                            } else {
                                terrors.push("Email not found");
                            }
                        }
                        rowdata.l_preparer = temails;
                        rowdata.l_preparer_ids = tids;
                        if (terrors.join("") !== "") errors.l_preparer = terrors;
                        if (warn_users.join("") !== "") warn_data.l_preparer = warn_users;
                    }
                    if(el[startindex + 1]){
                        let terrors = [];
                        let warn_users = [];
                        let tids = [];
                        let temails = el[startindex + 1].split(",");

                        temails = temails.map(email => email.trim());
                        for (let email of temails) {
                            if (this.useremailidmap[email]) {
                                let isPreparer = filterdata?.[0]?.submitter?.some(item => item.name === email);
                                let isApprover = filterdata?.[0]?.approver?.some(item => item.name === email);
                                let isRegionalApprover = filterdata?.[0]?.regional_approver?.some(item => item.name === email);
                                let isManager = filterdata?.[0]?.manager?.some(item => item.name === email);
                                if (( isSodEnabled && rowdata.l_preparer || []).indexOf(i) > -1) {
                                    terrors.push(`${this.$nova.labelsName('access_management','commentary_local_approver_label','Local Approver')} and ${this.$nova.labelsName('access_management','commentary_local_preparer_label','Local Preparer')} can't be the same`);
                                } else if (!isApprover && (isSodEnabled ? rowdata.l_preparer.indexOf(email) === -1 : true) && tids.indexOf(this.useremailidmap[email]) === -1) {
                                  tids.push(this.useremailidmap[email]);
                                  if (isPreparer) {
                                      warn_users.push(errorMessages.existingaspreparer);
                                  } else if (isRegionalApprover) {
                                      warn_users.push(errorMessages.existingasregionalapprover);
                                  } else if (isManager) {
                                      warn_users.push(errorMessages.existingasmanager);
                                  }
                                  terrors.push("");
                                } else {
                                    if (isApprover) {
                                      terrors.push(errorMessages.existingasapprover);
                                    } else if (rowdata.l_preparer.indexOf(email) > -1 && isSodEnabled){
                                      terrors.push(`${this.$nova.labelsName('access_management','commentary_local_preparer_label','Local Preparer')} and ${this.$nova.labelsName('access_management','commentary_local_approver_label','Local Approver')} can't be the same`);
                                    } else if(tids.indexOf(this.useremailidmap[email]) !== -1){
                                      terrors.push("Duplicate email found");
                                    }
                                }
                            } else {
                                terrors.push("Email not found");
                            }
                        }
                        rowdata.l_approver = temails;
                        rowdata.l_approver_ids = tids;
                        if (terrors.join("") !== "") errors.l_approver = terrors;
                        if (warn_users.join("") !== "") warn_data.l_approver = warn_users;
                    }
                    if(el[startindex + 2] ){
                        let terrors = [];
                        let warn_users = [];
                        let tids = [];
                        let temails = el[startindex + 2].split(",");
                        temails = temails.map(email => email.trim());

                        for (let email of temails) {
                            if (this.useremailidmap[email]) {
                                let isPreparer = filterdata?.[0]?.submitter?.some(item => item.name === email);
                                let isApprover = filterdata?.[0]?.approver?.some(item => item.name === email);
                                let isRegionalApprover = filterdata?.[0]?.regional_approver?.some(item => item.name === email);
                                let isManager = filterdata?.[0]?.manager?.some(item => item.name === email);
                                if ((rowdata.l_preparer || []).indexOf(i) > -1 && isSodEnabled) {
                                    terrors.push(`${this.$nova.labelsName('access_management','commentary_regional_approver_label','Regional Approver')} and ${this.$nova.labelsName('access_management','commentary_local_preparer_label','Local Preparer')} can't be the same`);
                                } else if ((rowdata.l_approver || []).indexOf(i) > -1 && isSodEnabled) {
                                    terrors.push(`${this.$nova.labelsName('access_management','commentary_regional_approver_label','Regional Approver')} and ${this.$nova.labelsName('access_management','commentary_local_approver_label','Local Approver')} can't be the same`);
                                } else if (!isRegionalApprover && ( isSodEnabled ? rowdata.l_preparer.indexOf(email) === -1  && rowdata.l_approver.indexOf(email) === -1 : true) && tids.indexOf(this.useremailidmap[email]) === -1) {
                                    tids.push(this.useremailidmap[email]);
                                    if (isPreparer) {
                                        warn_users.push(errorMessages.existingaspreparer);
                                    } else if (isApprover) {
                                        warn_users.push(errorMessages.existingasapprover);
                                    } else if (isManager) {
                                        warn_users.push(errorMessages.existingasmanager);
                                    }
                                    terrors.push("");
                                } else {
                                  if (isRegionalApprover) {
                                    terrors.push(errorMessages.existingasregionalapprover);
                                  } else if (rowdata.l_preparer.indexOf(email) > -1 && isSodEnabled){
                                    terrors.push(`${this.$nova.labelsName('access_management','commentary_local_preparer_label','Local Preparer')} and ${this.$nova.labelsName('access_management','commentary_regional_approver_label','Regional Approver')} can't be the same`);
                                  } else if (rowdata.l_approver.indexOf(email) > -1 && isSodEnabled){
                                    terrors.push(`${this.$nova.labelsName('access_management','commentary_local_approver_label','Local Approver')} and ${this.$nova.labelsName('access_management','commentary_regional_approver_label','Regional Approver')} can't be the same`);
                                  } else if(tids.indexOf(this.useremailidmap[email]) !== -1){
                                    terrors.push(`Duplicate email found`);
                                  }
                                }
                            } else {
                                terrors.push("Email not found");
                            }
                        }

                        rowdata.r_approver = temails;
                        rowdata.r_approver_ids = tids;
                        if (terrors.join("") !== "") errors.r_approver = terrors;
                        if (warn_users.join("") !== "") warn_data.r_approver = warn_users;
                    }
                    if(el[startindex + 3]){
                        let terrors = [];
                        let warn_users = [];
                        let tids = [];
                        let temails = el[startindex + 3].split(",");
                        temails = temails.map(email => email.trim());
                        for (let email of temails) {
                            let isPreparer = filterdata?.[0]?.submitter?.some(item => item.name === email);
                            let isApprover = filterdata?.[0]?.approver?.some(item => item.name === email);
                            let isRegionalApprover = filterdata?.[0]?.regional_approver?.some(item => item.name === email);
                            let isManager = filterdata?.[0]?.manager?.some(item => item.name === email);
                            if (this.useremailidmap[email]) {
                                if ((rowdata.l_preparer || []).indexOf(i) > -1 && isSodEnabled) {
                                    warn_users.push(`Manager and ${this.$nova.labelsName('access_management','commentary_local_preparer_label','Local Preparer')} can't be the same`);
                                } else if ((rowdata.l_approver || []).indexOf(i) > -1 && isSodEnabled) {
                                    warn_users.push(`Manager and ${this.$nova.labelsName('access_management','commentary_local_approver_label','Local Approver')} can't be the same`);
                                } else if ((rowdata.r_approver || []).indexOf(i) > -1 && isSodEnabled) {
                                    warn_users.push(`Manager and ${this.$nova.labelsName('access_management','commentary_regional_approver_label','Regional Approver')} can't be the same`);
                                } else if (!isManager && (isSodEnabled ?  rowdata.l_preparer.indexOf(email) === -1 && rowdata.l_approver.indexOf(email) === -1  && rowdata.r_approver.indexOf(email) === -1 : true) && tids.indexOf(this.useremailidmap[email]) === -1) {
                                    tids.push(this.useremailidmap[email]);
                                    if (isPreparer) {
                                        warn_users.push(errorMessages.existingaspreparer);
                                    } else if (isApprover) {
                                        warn_users.push(errorMessages.existingasapprover);
                                    } else if (isRegionalApprover) {
                                        warn_users.push(errorMessages.existingasregionalapprover);
                                    } 
                                    terrors.push("");
                                } else {
                                  if (isManager) {
                                    terrors.push(errorMessages.existingasmanager);
                                  } else if (rowdata.l_preparer.indexOf(email) > -1 && isSodEnabled){
                                    terrors.push(`Manager and ${this.$nova.labelsName('access_management','commentary_local_preparer_label','Local Preparer')} can't be the same`);
                                  } else if (rowdata.l_approver.indexOf(email) > -1 && isSodEnabled){
                                    terrors.push(`Manager and ${this.$nova.labelsName('access_management','commentary_local_approver_label','Local Approver')} can't be the same`);
                                  } else if (rowdata.r_approver.indexOf(email) > -1 && isSodEnabled){
                                    terrors.push(`Manager and ${this.$nova.labelsName('access_management','commentary_regional_approver_label','Regional Approver')} can't be the same`);
                                  } else if(tids.indexOf(this.useremailidmap[email]) !== -1){
                                    terrors.push(`Duplicate email found`);
                                  }
                                }
                            } else {
                                terrors.push("Email not found");
                            }
                        }
                        rowdata.manager = temails;
                        rowdata.manager_ids = tids;
                        if (terrors.join("") !== "") errors.manager = terrors;
                        if (warn_users.join("") !== "") warn_data.manager = warn_users;
                    }
                    if([0, 1, 2, 3].every(i => typeof el[startindex + i] === 'undefined')){
                      errors.rucode = "No users assigned"
                    }
                    if (Object.keys(errors).length > 0 || [0, 1, 2, 3].every(i => typeof el[startindex + i] === 'undefined')) {
                        errorFlag = true;
                    }
                    for (const key in rowdata) {
                      if (!rowdata[key] || rowdata[key].length === 0) {
                          delete rowdata[key];
                      }
                    }
                    filedata.push(rowdata);
                    errordata.push(errors);
                    warning_data.push(warn_data);
                }
              }
            }
            // Emit updates
            this.$emit('update:bulkSubmitRuFileData', filedata);
            this.$emit('update:bulkSubmitRuFileError', errordata);
            this.$emit('update:bulkSubmitRuFileWarn', warning_data);
            this.$emit('update:bulkSubmitRuFileErrorFlag', errorFlag);
            this.$emit('update:emptyRuCode', localEmptyRuCode);

          } else {
            this.$store.commit("sbError", "Invalid file");
          }
        }).catch(err => {
          this.$store.commit("sbError", err.message || err || "Unknown error!");
          console.log(err);
        }).finally(() => {
          this.$set(this.fileProcessing, key, 0);
          this.$emit('update:bulkSubmitRuLoading', false);
        })
      }
    }
  }
}
</script>